<template>
    <v-row
        no-gutters
        class="pl-9 pr-8 pt-8"
    >
        <EmailingConnectionsOverview :title="$t('Send emails')" />
    </v-row>
</template>

<script>

import EmailingConnectionsOverview from '../../../components/AppStore/EmailingConnectionsOverview.vue'

export default {
    name: "EmailingDialogEmailAddressesTab",
    components: {
        EmailingConnectionsOverview
    },
    props: {
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {

    }
};
</script>
